import { ChangeDetectionStrategy, Component, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isEmpty } from 'lodash';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { AdminEQueryEscalationSearchFieldsStorage } from '../../admin-e-query-escalation-search-fields-storage';
import { ItemsLoader } from '../escalation-search-field/escalation-search-field.component';

type SearchFields = {
    readonly [key in 'email' | 'eQueryId' | 'accessionNumber']: AbstractControl
};

export type SearchFieldsValues = {
    readonly [name in keyof SearchFields]: string
};

@Component({
    selector: 'escalation-emails-filter',
    template: require('./escalation-emails-filter.component.html'),
    styles: [require('./escalation-emails-filter.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EscalationEmailsFilterComponent {
    @Output()
    public search: Observable<SearchFieldsValues>;

    public readonly textFieldStyles = { 'width': '300px' };
    public readonly numberFieldStyles = { 'width': '100px' };

    public readonly emailSearchField = new FormControl(null);
    public readonly eQueryIdSearchField = new FormControl(null);
    public readonly accessionNumberSearchField = new FormControl(null);
    public readonly searchFields: SearchFields = {
        'email': this.emailSearchField,
        'eQueryId': this.eQueryIdSearchField,
        'accessionNumber': this.accessionNumberSearchField,
    };

    public readonly searchFieldFormGroup = new FormGroup(
        this.searchFields,
        this.atLeastOneRequiredField());

    constructor(
        private readonly searchFieldsStorage: AdminEQueryEscalationSearchFieldsStorage,
    ) {
        this.search = this.searchFieldFormGroup.valueChanges.pipe(
            distinctUntilChanged(),
            map((values: SearchFieldsValues) => values),
        );
    }

    public readonly emailsLoader: ItemsLoader<string> = (term: string) => {
        return this.searchFieldsStorage.loadEmails(term);
    }

    public readonly eQueriesLoader: ItemsLoader<number> = (term: string) => {
        return this.searchFieldsStorage.loadEQueries(term);
    }

    public readonly accessionNumbersLoader: ItemsLoader<string> = (term: string) => {
        return this.searchFieldsStorage.loadAccessionNumber(term);
    }

    private atLeastOneRequiredField(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const searchFieldValues: SearchFieldsValues = control.value;
            return isEmpty(searchFieldValues.email)
                && !searchFieldValues.eQueryId
                && isEmpty(searchFieldValues.accessionNumber)
                    ? { 'required': true }
                    : null;
        };
    }
}
